module.exports = __webpack_public_path__ + "img/search.41de3ee2.jpg";